import { h } from 'preact';
import { Ref, useCallback, useLayoutEffect, useState } from 'preact/hooks';
import { useIsInitialRender } from './useIsInitialRender';

export const useAccordionAttrs = (
  ref: Ref<HTMLElement>,
  options: { isOpen: boolean; transitionDuration?: string }
): Pick<h.JSX.HTMLAttributes<HTMLElement>, 'style' | 'onTransitionEnd'> => {
  const isInitialRender = useIsInitialRender();
  const [style, setStyle] = useState<h.JSX.CSSProperties>({});
  const { isOpen } = options;

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const height = el.clientHeight;

    const transitionDuration = isInitialRender
      ? '0'
      : options.transitionDuration ?? '0.3s';

    if (isOpen) {
      setStyle((prev) => ({ ...prev, height: 0, transitionDuration: '0' }));

      requestAnimationFrame(() => {
        setStyle((prev) => ({ ...prev, height, transitionDuration }));
      });
    } else {
      setStyle((prev) => ({ ...prev, height, transitionDuration: '0' }));

      requestAnimationFrame(() => {
        setStyle((prev) => ({
          ...prev,
          height: 0,
          transitionDuration,
        }));
      });
    }
  }, [isOpen]);

  const onTransitionEnd = useCallback(() => {
    if (isOpen) {
      setStyle((prev) => ({ ...prev, height: 'initial' }));
    }
  }, [isOpen]);

  return {
    style,
    onTransitionEnd,
  };
};
